import { useEffect, useState } from "react";
import { getUserAddresses } from "../../services/checkoutApi";
import { useCheckoutStore } from "../../store/checkoutStore";
import { useUpdateAddress } from "../../features/Checkout/useUpdateAddress";

import AddressCard from "./AddressCard";
import AddressFormModal from "../Address/AddressFormModal";
import Button from "../Button";

export default function AddressSelectorModal({ onClose }) {
  const destinationAddress = useCheckoutStore(
    (state) => state.destinationAddress
  );

  const { mutateAsync: updateAddress, isPending: isUpdatingAddress } =
    useUpdateAddress();

  const [addresses, setAddresses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editingAddress, setEditingAddress] = useState(null);
  const [formOpen, setFormOpen] = useState(false);

  const fetchAddresses = async () => {
    setLoading(true);

    try {
      const res = await getUserAddresses();
      setAddresses(res.data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAddresses();
  }, []);

  const handleSelect = async (address) => {
    try {
      await updateAddress(address);
      onClose();
    } catch (err) {
      console.error(err);
    }
  };

  const handleCreate = () => {
    setEditingAddress(null);
    setFormOpen(true);
  };

  const handleEdit = (address) => {
    setEditingAddress(address);
    setFormOpen(true);
  };

  return (
    <>
      <div className="fixed inset-0 bg-black/40 z-50 flex justify-center items-center">
        <div className="bg-white w-full max-w-2xl rounded-2xl p-6 max-h-[90vh] overflow-y-auto">
          <div className="flex justify-between items-center mb-6">
            <h2 className="text-xl font-bold">انتخاب آدرس</h2>

            <button onClick={onClose} disabled={isUpdatingAddress}>
              ✕
            </button>
          </div>

          <div className="mb-4">
            <Button
              variant="primary"
              onClick={handleCreate}
              disabled={isUpdatingAddress}
            >
              افزودن آدرس جدید
            </Button>
          </div>

          {loading ? (
            <div>در حال بارگذاری...</div>
          ) : (
            <div className="space-y-4">
              {addresses.map((address) => (
                <AddressCard
                  key={address.id}
                  address={address}
                  selected={destinationAddress?.id === address.id}
                  onSelect={handleSelect}
                  onEdit={handleEdit}
                />

              ))}
            </div>
          )}

          {isUpdatingAddress && (
            <div className="mt-4 text-sm text-blue-600">
              در حال به‌روزرسانی آدرس و محاسبه مجدد روش‌های ارسال...
            </div>
          )}
        </div>
      </div>

      {formOpen && (
        <AddressFormModal
          address={editingAddress}
          isEditing={!!editingAddress}
          onClose={() => setFormOpen(false)}
          onSuccess={fetchAddresses}
          address_type="customer"
          user="user"
        />
      )}
    </>
  );
}
